






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {
  }
})
export default class IdrMianZhuanjia extends Vue {
  @Prop()
  private current: any;
  @Prop()
  private faceId: any;
}
